import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Thumbs, Mousewheel, Autoplay, EffectFade } from "swiper/modules";

// Import images
import img1 from "../assets/images/sliders/vertical/1.webp";
import img2 from "../assets/images/sliders/vertical/2.webp";
import img3 from "../assets/images/sliders/vertical/3.webp";

// Import Swiper styles
import "swiper/css";
import "swiper/css/thumbs";
import "swiper/css/effect-fade";

const VerticalProcessSlider = () => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  const processItems = [
    {
      icon: "icon-question-and-answer",
      title: "1. Initial Conversation",
      shortDescription: "30-45 min",
      description:
        "Understand your practice, client mix, software, and compliance needs. Practical, technical discussion.",
      image: img1,
    },
    {
      icon: "icon-strategy",
      shortDescription: "A few business days",
      title: "2. Clarifications & Consideration",
      description:
        "Review scope, workflow, data access, and turnaround preferences at your own pace.",
      image: img2,
    },
    {
      icon: "icon-idea-1",
      title: "3. Scope Confirmation & Engagement Outline ",
      shortDescription: "1-2 business days",
      description:
        "Finalise services, pricing, timelines, and delivery model - tailored to your practice.",
      image: img3,
    },
    {
      icon: "icon-document",
      title: "4. Secure Access & Process Alignment",
      shortDescription: "2-4 business days",
      description:
        "Set up secure access, align workflows, and document instructions for seamless integration.",
      image: img1,
    },
    {
      icon: "icon-strategy",
      title: "5. Pilot Assignment (Optional but recommended) ",
      shortDescription: "1-2 weeks",
      description:
        "Test quality, documentation, and turnaround in a live environment. Feedback fine-tunes delivery before scaling.",
      image: img2,
    },
    {
      icon: "icon-work-team",
      title: "6. Resource Planning & Preparation",
      shortDescription: "Variable depending on commitment",
      description:
        "Based on the pilot outcomes, we allocate or hire dedicated staff and fully train them to deliver work per Inscape’s quality standards. This ensures smooth, long-term support.",
      image: img3,
    },
    {
      icon: "icon-agreement",
      title: "7. Ongoing Delivery & Scalable Support",
      shortDescription: "Ongoing",
      description:
        "Dedicated resources, structured quality reviews, and flexible support during peak periods.",
      image: img1,
    },
  ];

  return (
    <section className="process-layout1 section-with-space-start bg-gray overflow-hidden py-0 hide-slider-in-mobile">
      <div className="container-fluid">
        {/* Desktop View */}
        <div className="row d-none d-lg-flex">
          <div className="col-sm-12 col-md-6 col-lg-6">
            <div className="mw-480 pt-130">
              <div className="heading-layout2 mb-60">
                <h2 className="heading-subtitle color-primary">
                  How does it work?
                </h2>
                <h3 className="heading-title">
                  From Introduction to Integration - The Inscape Onboarding
                  Experience
                </h3>
              </div>

              {/* Vertical Slider */}
              <Swiper
                direction="vertical"
                slidesPerView={3}
                slidesPerGroup={1}
                spaceBetween={60}
                speed={1200}
                mousewheel={true}
                loop={true}
                watchSlidesProgress={true}
                // autoplay={{
                //   delay: 5000,
                //   disableOnInteraction: false,
                // }}
                thumbs={{ swiper: thumbsSwiper }}
                modules={[Thumbs, Mousewheel, Autoplay]}
                breakpoints={{
                  1200: {
                    slidesPerView: 2,
                    slidesPerGroup: 1,
                  },
                }}
                className="slider-vertical"
              >
                {processItems.map((item, index) => (
                  <SwiperSlide key={index}>
                    <div className="process-item">
                      <div className="process-icon">
                        <i className={item.icon}></i>
                      </div>
                      <div className="process-body">
                        <h4 className="process-title">{item.title}</h4>
                        <p
                          className="process-desc mb-0"
                          style={{ fontSize: "14px" }}
                        >
                          {item.description}
                        </p>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>

          {/* Thumbs Slider */}
          <div className="col-sm-12 col-md-6 col-lg-6">
            <Swiper
              direction="vertical"
              slidesPerView={1}
              slidesPerGroup={1}
              spaceBetween={0}
              watchSlidesProgress={true}
              autoHeight={true}
              effect="fade"
              modules={[Thumbs, EffectFade]}
              onSwiper={setThumbsSwiper}
              className="slider-vertical-thumbs"
            >
              {processItems.map((item, index) => (
                <SwiperSlide key={index}>
                  <img src={item.image} alt="banner" loading="lazy" />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>

        {/* Mobile View */}
        <div className="d-block d-lg-none">
          <div className="row">
            <div className="col-sm-10 col-md-6">
              <div className="heading-layout2 mb-60">
                <h2 className="heading-subtitle color-primary">
                  How does it work?
                </h2>
                <h3 className="heading-title">
                  Expect and deliver the highest quality outcomes.
                </h3>
              </div>
            </div>
          </div>

          {processItems.map((item, index) => (
            <div className="row align-items-center" key={index}>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="process-item mt-30">
                  <div className="process-icon">
                    <i className={item.icon}></i>
                  </div>
                  <div className="process-body">
                    <h4 className="process-title">{item.title}</h4>
                    <p className="process-desc mb-0">{item.description}</p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <img
                  src={item.image}
                  className="mt-30"
                  alt="banner"
                  loading="lazy"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VerticalProcessSlider;
